import { useTranslation } from 'react-i18next';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  SectionContainer,
} from './SegmentationThree.style';

const SegmentationThree = () => {
  const { t, i18n } = useTranslation('segmentation');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>
          {t('segmentationThree.title.spanBefore')}
          {i18n.language !== 'en' && <span>2</span>}{' '}
          {t('segmentationThree.title.spanAfter')}
        </h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <p>
          {t('segmentationThree.paragraph.spanBefore')}
          <span>2</span> {t('segmentationThree.paragraph.spanAfter')}
        </p>

        <TextBox1>
          <TextBox2>
            <p>
              <span>1.</span>
              {t('segmentationThree.ulOne.ulTitle')}
            </p>
            <ul>
              <li>{t('segmentationThree.ulOne.liOne')}</li>
              <li>{t('segmentationThree.ulOne.liTwo')}</li>
            </ul>
          </TextBox2>

          <TextBox2>
            <p>
              <span>2.</span>
              {t('segmentationThree.ulTwo.ulTitle')}
            </p>
            <ul>
              <li>{t('segmentationThree.ulTwo.liOne')}</li>
              <li>{t('segmentationThree.ulTwo.liTwo')}</li>
            </ul>
          </TextBox2>

          <TextBox2>
            <p>
              <span>3.</span>
              {t('segmentationThree.ulThree.ulTitle')}
            </p>
            <ul>
              <li>{t('segmentationThree.ulThree.liOne')}</li>
              <li>{t('segmentationThree.ulThree.liTwo')}</li>
            </ul>
          </TextBox2>
        </TextBox1>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default SegmentationThree;
